import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import { FormContext } from "../ImsAuditMainstage2";
import * as yup from "yup";
import FormikControl from '../../../../hoc/formikComponents/FormikControl.js'

function BasicInfo4() {
    const { activeStepIndex, setActiveStepIndex, formData, setFormData,
        technicalExpertList, setTechnicalExpertList,
        leadauditorList, setLeadauditorList,
        initialValues, setInitialValues,
        mutationTechnicalExpertDetails, mutationLeadAudiorDetails, mutationAssisAuditorDetails,
        OrgList, mutationgetCompanyDetails,
        saveData, options,
        assitAuditorList, setassitAuditorList,
        OrgListOrg, typeofsatisfactory

    } = useContext(FormContext);

    const renderError = (message) => (
        <p className="italic text-red-600">{message}</p>
    );

    const ValidationSchema = yup.object().shape({
        // workspaceName: yup.string().required(),
        // workspaceURL: yup.string().url().required(),
    });

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const data = { ...formData, ...values };
                saveData(values);
                setActiveStepIndex(activeStepIndex + 1);
            }}>
            <Form className="flex flex-col justify-center items-center">


                <div className="formOuterDiv">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">Sr.No</th>
                                <th scope="col" width="30%">Checkpoints</th>
                                <th scope="col" >Satisfactory(Yes/No)</th>
                                <th scope="col" width="50%">Remarks / Concern No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>‘Understanding regarding the requirement of the standard’ and ‘Awareness of System’ to client’s personnel</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Evaluate the client's location and site-specific conditions</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory1' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark1' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Leadership and commitment</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory2' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark2' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Compliance with statutory and regulatory requirements related to Products & Services, EMS& OHSMS</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory3' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark3' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Review Client Profile to evaluate the adequacy of the OHS hazards identified for the Scope of the organization’s activities</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory4' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark4' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Any other area(s) audited </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory5' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark5' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Overall preparedness for Stage 2 Audit </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory6' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark6' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Identify issues that require special attention during the Stage 2 audit</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory7' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark7' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td rowSpan={3}>9</td>
                                <td>Are all the processes audited as per Plan?</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory8' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark8' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>Correction & Corrective Action(s) adequate?</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory9' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark9' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>Audit process effective?</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory10' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark10' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td rowSpan={3}>10</td>
                                <td>All the mandatory INPUTS discussed?</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory11' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark11' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>Review OUTPUT adequate?</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory12' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark12' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>Action plan includes training of 3 employees for iso 14001 and 45001 internal auditors.
Action plan includes resource allocation of a full time safety officer at site
</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory13' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark13' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td rowSpan={2}>11</td>
                                <td>Objectives verified for current year</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory11' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark11' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>Tracking done for objectives</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory12' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark12' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td rowSpan={2}>12</td>
                                <td>Risk & Opportunities</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory13' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark13' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>Action plan taken on risk and opportunities</td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofsatisfactory} name='typeofsatisfactory14' style={{ textAlign: "center" }} />
                                </td>

                                <td>
                                    <FormikControl control='inputtable' type="text" name='typeofsatisfactoryremark14' className="form-control" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-sm-1"></div>

                        <div className="col-sm-2">
                            <button type="button" className="btn btn-primary float-left" onClick={() => setActiveStepIndex(activeStepIndex - 1)}>previous</button>
                        </div>
                        <div className="col-sm-7"></div>
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-primary float-right">Next</button>
                        </div>
                    </div>
                </div>
            </Form>
        </Formik>
    );
}

export default BasicInfo4;